<child-header [title]="'Confirm Upgrade'" (closeEvent)="onNoClick()"></child-header>

<mat-spinner *ngIf="loading" mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20" style="margin: 100px auto;"></mat-spinner>

<div *ngIf="!loading" mat-dialog-content>
  <p style="white-space: pre-line">Please note by upgrading this plan you agree to the currently committed term. No cancellation period is provided for plan upgrades.</p>
  <br>
  <div style="height: 125px;">
    <table style="margin: auto;">
      <tr>
        <td>
          Current charges
        </td>
        <td style="text-align: right;">
          <span class="color-red bold"> {{ currenAmount |
            currency:'AUD':'symbol-narrow':'.2-2'}}</span>
        </td>
      </tr>
      <tr>
        <td>
          Estimated additional prorated charges
        </td>
        <td style="text-align: right;">
          <span class="color-red bold"> {{ additionalAmount |
            currency:'AUD':'symbol-narrow':'.2-2'}}</span>
        </td>
      </tr>
      <tr>
        <td>
          Estimated total amount for next billing
        </td>
        <td style="text-align: right;">
          <span class="color-red bold"> {{ nextBillingAmount |
            currency:'AUD':'symbol-narrow':'.2-2'}}</span>
        </td>
      </tr>
  
    </table>
  </div>
  <div style="margin: 10px auto; text-align: center;">
    <p>Are you sure to upgrade immediately ?</p>
  </div>
  <div style="text-align: center;">
    <button mat-button class="button button-red button-large nce-large-button continue"
      (click)="immediately()">Immediately</button>
  </div>
</div>